import { render } from "./VueFinalPopover.vue?vue&type=template&id=621981f3&scoped=true"
import script from "./VueFinalPopover.vue?vue&type=script&lang=js"
export * from "./VueFinalPopover.vue?vue&type=script&lang=js"

import "./VueFinalPopover.vue?vue&type=style&index=0&id=621981f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621981f3"]])

export default __exports__